import { observer } from 'mobx-react-lite'
import { CheckboxInputContainer } from '@/components/inputs/CheckboxInputContainer'
import { SubmitJobDialog } from '@/features/jobs/details/components/SubmitJobDialog'
import { type SubmitJobDialogViewModel } from './SubmitJobDialogViewModel'

export interface SubmitJobDialogContainerProps {
  vm: SubmitJobDialogViewModel
}

export const SubmitJobDialogContainer = observer(
  function SubmitJobDialogContainer({ vm }: SubmitJobDialogContainerProps) {
    return (
      <SubmitJobDialog
        showing={vm.modal.showing}
        requestedProName={vm.requestedProName}
        billExternalField={
          vm.canBillExternal && (
            <CheckboxInputContainer
              model={vm}
              field="shouldBillExternal"
              label="Bill external"
            />
          )
        }
        isSubmitPending={vm.submit.pending}
        isSubmitRejected={vm.submit.rejected}
        submitError={vm.submit.error}
        onClose={vm.modal.close}
        onSubmit={vm.submit}
        onResetSubmit={vm.submit.reset}
        testId="submit-job-dialog"
        closeButtonTestId="submit-job-dialog-close-button"
        submitButtonTestId="submit-job-dialog-submit-button"
      />
    )
  },
)
